module.exports = __webpack_public_path__ + "img/rule.0f5590b7.svg";